<template>
  <div class="self_adaption">
    <div class="self_adaption_main">
      <el-form ref="form" :model="form" label-width="96px" label-position="right" class="FormFlex"
        style="justify-content: space-between;">
        <div class="FormBtn" style="width:100%;display:flex;justify-content:flex-end;">
          <el-button size="medium" @click="back()">返回首页</el-button>
        </div>
      </el-form>
      <el-tabs v-model="tabPosition">
        <el-tab-pane label="发言内容编辑" name="1"></el-tab-pane>
        <el-tab-pane label="问答内容编辑" name="2"></el-tab-pane>
        <el-tab-pane label="直播图片上传" name="3"></el-tab-pane>
      </el-tabs>
      <Speak v-if="tabPosition == '1'" :dataId="dataId"></Speak>
      <QuestionsAnswers v-if="tabPosition == '2'" :dataId="dataId"></QuestionsAnswers>
      <Imger v-if="tabPosition == '3'" :dataId="dataId"></Imger>
    </div>
  </div>
</template>

<script>
import Imger from '@/components/edit/img.vue'
import Speak from '@/components/edit/speak.vue'
import QuestionsAnswers from '@/components/edit/questionsAnswers.vue'
export default {
  name: 'Progress',
  components: {
    Imger,
    Speak,
    QuestionsAnswers
  },
  data () {
    return {
      dataId: '',
      tabPosition: '1',
      form: {
        current: 1,
        size: 10
      },
      total: 0
    };
  },
  created () {
    this.dataId = this.$route.query.id;
  },
  methods: {
    back () {
      this.$router.push('/list');
    },
    //警告提示
    Messager (text, messageType) {
      this.$message({ message: text, type: messageType })
    }
  }
};
</script>

<style scoped>
.el-radio-group .el-radio-button__inner {
  background: #A30014 !important;
}
</style>
